<app-batchs-detail-summary-status
    [batch]="batch"
></app-batchs-detail-summary-status>
<app-batchs-detail-summary-description
    [batch]="batch"
></app-batchs-detail-summary-description>